module.exports = __webpack_public_path__ + "img/nt109-04-98.prt.59653b86.jpg";